import { useState, type ReactNode } from 'react';

interface CollapsibleBlockProps {
    title: string;
    icon?: ReactNode;
    hasValue?: boolean;
    defaultOpen?: boolean;
    children: ReactNode;
}

/**
 * Bloc dépliable utilisé pour "Affichage conditionnel" et "Impact sur le prix".
 * S'ouvre par défaut si la valeur est déjà renseignée.
 */
export function CollapsibleBlock({
    title,
    icon,
    hasValue = false,
    defaultOpen,
    children,
}: CollapsibleBlockProps) {
    const [open, setOpen] = useState(defaultOpen ?? hasValue);

    return (
        <div className={`collapsible${open ? ' is-open' : ''}${hasValue ? ' has-value' : ''}`}>
            <button
                type="button"
                className="collapsible-head"
                onClick={() => setOpen((v) => !v)}
                aria-expanded={open}
            >
                {icon && <span className="collapsible-icon" aria-hidden>{icon}</span>}
                <span className="collapsible-title">{title}</span>
                {hasValue && <span className="collapsible-dot" aria-label="Configuré" />}
                <svg
                    width="14" height="14" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round"
                    className="collapsible-chevron"
                    aria-hidden
                >
                    <polyline points="6 9 12 15 18 9" />
                </svg>
            </button>
            {open && <div className="collapsible-body">{children}</div>}
        </div>
    );
}
